import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { EnumIroStatus, EnumIroType } from '~/types/types';
var EsrsStatus = /*#__PURE__*/function (EsrsStatus) {
  EsrsStatus["notMaterial"] = "notMaterial";
  EsrsStatus["impactMaterial"] = "impactMaterial";
  EsrsStatus["financialMaterial"] = "financialMaterial";
  EsrsStatus["doubleMaterial"] = "doubleMaterial";
  EsrsStatus["notAssessed"] = "notAssessed";
  return EsrsStatus;
}(EsrsStatus || {});
export default /*#__PURE__*/_defineComponent({
  __name: 'EsrsStatus',
  props: {
    section: null
  },
  setup: function setup(__props) {
    var props = __props;
    var chipInfoMapping = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EsrsStatus.notMaterial, {
      color: '#8FA5AF',
      key: 'notMaterial'
    }), EsrsStatus.impactMaterial, {
      color: '#DA575E',
      key: 'impactMaterial'
    }), EsrsStatus.financialMaterial, {
      color: '#00679E',
      key: 'financialMaterial'
    }), EsrsStatus.doubleMaterial, {
      color: '#8F5FCC',
      key: 'doubleMaterial'
    }), EsrsStatus.notAssessed, {
      color: '#F3F8FB',
      textColor: '#8FA5AF',
      key: 'notAssessed'
    });
    var getStatusForIros = function getStatusForIros(iros) {
      if (iros.length === 0) {
        return 'notAssessed';
      }
      var materialIros = iros.filter(function (link) {
        var _link$iro;
        return ((_link$iro = link.iro) === null || _link$iro === void 0 ? void 0 : _link$iro.status) === EnumIroStatus.Material;
      });
      var notMaterialIros = iros.filter(function (link) {
        var _link$iro2;
        return ((_link$iro2 = link.iro) === null || _link$iro2 === void 0 ? void 0 : _link$iro2.status) === EnumIroStatus.NotMaterial;
      });
      if (materialIros.length > 0) return 'material';
      if (notMaterialIros.length > 0) return 'notMaterial';
      return 'notAssessed';
    };
    var esrsStatus = computed(function () {
      var _props$section$iroLin, _props$section, _props$section$iroLin2, _props$section$iroLin3, _props$section2, _props$section2$iroLi;
      // Order of importance is Material -> Not Assessed -> Not Material
      // Since we have to be sure before we label something as not material.
      // If any of the Imapct IROs are material, then the IRO is material, irresepctive of whetehr others are NOT assessed or NOT material.
      // Similarly if any are not assessed, the IRO is not assessed, irrespective of whether others are NOT material.
      var impactIros = (_props$section$iroLin = props === null || props === void 0 ? void 0 : (_props$section = props.section) === null || _props$section === void 0 ? void 0 : (_props$section$iroLin2 = _props$section.iroLinks) === null || _props$section$iroLin2 === void 0 ? void 0 : _props$section$iroLin2.filter(function (link) {
        var _link$iro3, _link$iro4;
        return ((_link$iro3 = link.iro) === null || _link$iro3 === void 0 ? void 0 : _link$iro3.type) === EnumIroType.PositiveImpact || ((_link$iro4 = link.iro) === null || _link$iro4 === void 0 ? void 0 : _link$iro4.type) === EnumIroType.NegativeImpact;
      })) !== null && _props$section$iroLin !== void 0 ? _props$section$iroLin : [];
      var financialIros = (_props$section$iroLin3 = props === null || props === void 0 ? void 0 : (_props$section2 = props.section) === null || _props$section2 === void 0 ? void 0 : (_props$section2$iroLi = _props$section2.iroLinks) === null || _props$section2$iroLi === void 0 ? void 0 : _props$section2$iroLi.filter(function (link) {
        var _link$iro5, _link$iro6;
        return ((_link$iro5 = link.iro) === null || _link$iro5 === void 0 ? void 0 : _link$iro5.type) === EnumIroType.Risk || ((_link$iro6 = link.iro) === null || _link$iro6 === void 0 ? void 0 : _link$iro6.type) === EnumIroType.Opportunity;
      })) !== null && _props$section$iroLin3 !== void 0 ? _props$section$iroLin3 : [];
      var impactStatus = getStatusForIros(impactIros);
      var financialStatus = getStatusForIros(financialIros);
      if (impactStatus === 'material' && financialStatus === 'material') {
        return EsrsStatus.doubleMaterial;
      } else if (impactStatus === 'material') {
        return EsrsStatus.impactMaterial;
      } else if (financialStatus === 'material') {
        return EsrsStatus.financialMaterial;
      } else if (impactStatus === 'notAssessed' && financialStatus === 'notAssessed') {
        return EsrsStatus.notAssessed;
      } else {
        return EsrsStatus.notMaterial;
      }
    });
    return {
      __sfc: true,
      props: props,
      EsrsStatus: EsrsStatus,
      chipInfoMapping: chipInfoMapping,
      getStatusForIros: getStatusForIros,
      esrsStatus: esrsStatus
    };
  }
});